import { render, staticRenderFns } from "./UserLeavePage.vue?vue&type=template&id=e1d06efc"
import script from "./UserLeavePage.vue?vue&type=script&lang=js"
export * from "./UserLeavePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports